var map = {
	"./en/clinic_config.json": [
		86046,
		6046
	],
	"./en/general.json": [
		51329,
		1329
	],
	"./en/translationEn.json": [
		42585,
		2585
	],
	"./en/user_config.json": [
		36091,
		6091
	],
	"./es/clinic_config.json": [
		56913,
		6913
	],
	"./es/general.json": [
		8022,
		8022
	],
	"./es/translationEs.json": [
		34189,
		4189
	],
	"./es/user_config.json": [
		69584,
		9584
	],
	"./hi/clinic_config.json": [
		222,
		222
	],
	"./hi/general.json": [
		44865,
		4865
	],
	"./hi/translationHi.json": [
		21333,
		1333
	],
	"./hi/user_config.json": [
		30427,
		427
	],
	"./pt/clinic_config.json": [
		94985,
		4985
	],
	"./pt/general.json": [
		4814,
		4814
	],
	"./pt/translationPt.json": [
		53405,
		3405
	],
	"./pt/user_config.json": [
		55464,
		5464
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 72096;
module.exports = webpackAsyncContext;